var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { PureComponent } from "react";
import { injectIntl } from "@irati/utils/lang";
import { Row, Col } from "react-bootstrap";
import Label3 from "@irati/ui/src/Menu/Label3";
import { Hr } from "@irati/ui/src/Layout";
import FlexSpaceBetween from "./styled/FlexSpaceBetween";
export var ALL = "admin.components.alphabetSearch.all.text";
var alphabet = __spreadArrays([ALL], "abcdefghijklmnopqrstuvwxyz".toUpperCase().split(""));
var AlphabetSearch = /** @class */ (function (_super) {
    __extends(AlphabetSearch, _super);
    function AlphabetSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSearch = function (letter) {
            var selectedLetter = letter === ALL ? null : letter;
            return _this.props.onSearch(selectedLetter);
        };
        return _this;
    }
    AlphabetSearch.prototype.render = function () {
        var _this = this;
        var _a = this.props, formatMessage = _a.formatMessage, variables = _a.variables;
        var selectedLetter = variables.lastNameCharacter;
        return (React.createElement(Row, null,
            React.createElement(Col, { xs: 12 },
                React.createElement(FlexSpaceBetween, null, alphabet.map(function (letter, index) { return (React.createElement(Label3, { key: letter, onClick: function () { return _this.handleSearch(letter); }, selected: selectedLetter === letter }, index === 0 ? formatMessage({ id: letter }) : letter)); })),
                React.createElement(Hr, null))));
    };
    return AlphabetSearch;
}(PureComponent));
export { AlphabetSearch };
export default injectIntl(AlphabetSearch);
